<style scoped>
.two-part {
  width: 50%;
  padding: 10px;
}
.form-group:not([class*=' col-']) {
  width: 100%;
  width: 33.333333%;
  padding-left: 5px;
  padding-right: 5px;
  padding-top: -5px;
  padding-bottom: -5px;
}
.fixHeightScrollable {
  overflow: auto;
  height: 500px;
}
</style>

<template>
  <div>
    <b-form validated @submit="onSubmit" @reset="onReset">
      <div class="d-flex justify-content-between">
        <div>
          <b-button-group v-if="editableOps">
            <b-button type="submit" variant="outline-primary" size="sm"
              ><span v-if="form.intId === undefined">Save</span><span v-else>Update</span></b-button
            >
            <b-button type="reset" variant="outline-danger" size="sm"
              >Reset</b-button
            >
          </b-button-group>
        </div>
      </div>
    </b-form>
    <br />
    <div class="overflow-auto">
      <div>
        <hr />
        <div class="fixHeightScrollable">
          <h5>General</h5>
          <hr />
          <b-form-group
            id="input-group-obstruction"
            label="Obstruction:"
            label-for="input-obstruction"
          >
            <b-form-input
              id="input-obstruction"
              v-model="form.obstruction"
              type="text"
              placeholder="Enter Obstruction"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-wellStatus"
            label="Well status:"
            label-for="input-wellStatus"
          >
            <b-form-select
              id="input-wellStatus"
              v-model="form.wellStatus"
              type="text"
              placeholder="Enter Well status"
              :options="optionComboWellStatus"
              :disabled="!editable"
            ></b-form-select>
          </b-form-group>
          <b-form-group
            id="input-group-startDateTime"
            label="Start date time:"
            label-for="input-startDateTime"
          >
            <b-form-input
              id="input-startDateTime"
              v-model="form.startDateTime"
              type="datetime-local"
              placeholder="Enter Start date time"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-endDateTime"
            label="End date time:"
            label-for="input-endDateTime"
          >
            <b-form-input
              id="input-endDateTime"
              v-model="form.endDateTime"
              type="datetime-local"
              placeholder="Enter End date time"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-requiredDate"
            label="Required date:"
            label-for="input-requiredDate"
          >
            <b-form-input
              id="input-requiredDate"
              v-model="form.requiredDate"
              type="datetime-local"
              placeholder="Enter Required date"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-fishingNo"
            label="Fishing no:"
            label-for="input-fishingNo"
          >
            <b-form-input
              id="input-fishingNo"
              v-model="form.fishingNo"
              type="number"
              step="0.001"
              placeholder="Enter Fishing no"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-fishingType"
            label="Fishing type:"
            label-for="input-fishingType"
          >
            <b-form-select
              id="input-fishingType"
              v-model="form.fishingType"
              type="text"
              placeholder="Enter Fishing type"
              :options="optionComboFishingType"
              :disabled="!editable"
            ></b-form-select>
          </b-form-group>
          <b-form-group
            id="input-group-fishingCause"
            label="Fishing cause:"
            label-for="input-fishingCause"
          >
            <b-form-select
              id="input-fishingCause"
              v-model="form.fishingCause"
              type="text"
              placeholder="Enter Fishing cause"
              :options="optionComboFishingCause"
              :disabled="!editable"
            ></b-form-select>
          </b-form-group>
          <b-form-group
            id="input-group-fishingImmediateCause"
            label="Fishing immediate cause:"
            label-for="input-fishingImmediateCause"
          >
            <b-form-select
              id="input-fishingImmediateCause"
              v-model="form.fishingImmediateCause"
              type="text"
              placeholder="Enter Fishing immediate cause"
              :options="optionComboFishingImmediateCause"
              :disabled="!editable"
            ></b-form-select>
          </b-form-group>
          <b-form-group
            id="input-group-operationSuccess"
            label="Operation success:"
            label-for="input-operationSuccess"
          >
            <b-form-checkbox
              id="input-operationSuccess"
              v-model="form.operationSuccess"
              type="number"
              step="0.001"
              :value="1"
              :unchecked-value="0"
              placeholder="Enter Operation success"
              :disabled="!editable"
              >Success</b-form-checkbox
            >
          </b-form-group>
          <b-form-group
            id="input-group-holeSize"
            label="Hole size:"
            label-for="input-holeSize"
          >
            <b-form-input
              id="input-holeSize"
              v-model="form.holeSize"
              type="number"
              step="0.001"
              placeholder="Enter Hole size"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-departmentName"
            label="Department name:"
            label-for="input-departmentName"
          >
            <b-form-input
              id="input-departmentName"
              v-model="form.departmentName"
              type="text"
              placeholder="Enter Department name"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-rigSuper1"
            label="Rig super1:"
            label-for="input-rigSuper1"
          >
            <b-form-input
              id="input-rigSuper1"
              v-model="form.rigSuper1"
              type="text"
              placeholder="Enter Rig super1"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-rigSuper2"
            label="Rig super2:"
            label-for="input-rigSuper2"
          >
            <b-form-input
              id="input-rigSuper2"
              v-model="form.rigSuper2"
              type="text"
              placeholder="Enter Rig super2"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-rigSuper3"
            label="Rig super3:"
            label-for="input-rigSuper3"
          >
            <b-form-input
              id="input-rigSuper3"
              v-model="form.rigSuper3"
              type="text"
              placeholder="Enter Rig super3"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-recommendations"
            label="Recommendations:"
            label-for="input-recommendations"
          >
            <b-form-input
              id="input-recommendations"
              v-model="form.recommendations"
              type="text"
              placeholder="Enter Recommendations"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>

          <hr />
          <h5>Free Point</h5>
          <hr />
          <fishing-free-point :submit-id="submitId" :editable-ops="editable" />

          <hr />
          <h5>String Shot</h5>
          <hr />
          <fishing-string-shot :submit-id="submitId" :editable-ops="editable" />

          <hr />
          <h5>Wellbore Obstruction</h5>
          <hr />
          <fishing-wellbore-obstruction
            :submit-id="submitId"
            :editable-ops="editable"
          />

          <hr />
          <h5>Responsible Parties</h5>
          <hr />
          <fishing-responsible-parties
            :submit-id="submitId"
            :editable-ops="editable"
          />

          <hr />
          <h5>Results</h5>
          <hr />
          <fishing-result :submit-id="submitId" :editable-ops="editable" />

          <hr />
          <h5>Remarks</h5>
          <hr />
          <b-form-group
            id="input-group-remarks"
            label="Remarks:"
            label-for="input-remarks"
            style="width: 100%"
          >
            <b-form-textarea
              id="input-remarks"
              v-model="form.remarks"
              type="text"
              rows="5"
              placeholder="Enter Remarks"
            ></b-form-textarea>
          </b-form-group>
        </div>
        <hr />
      </div>

      <!-- <p>{{ selectedRow }}</p> -->
    </div>
  </div>

  <!-- MODALS -->
</template>

<script>
import Vue from 'vue'
import VueFormGenerator from 'vue-form-generator'
import 'vue-form-generator/dist/vfg.css'
import { formMethods, formComputed } from '@state/helpers'
import FishingFreePoint from '@components/form/drilling-activity/fishing-free-point.vue'
import FishingResult from '@components/form/drilling-activity/fishing-result'
import FishingStringShot from '@components/form/drilling-activity/fishing-string-shot.vue'
import FishingWellboreObstruction from '@components/form/drilling-activity/fishing-wellbore-obstruction.vue'
import FishingResponsibleParties from '@components/form/drilling-activity/fishing-responsible-parties'
import notify from "devextreme/ui/notify"
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'

Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
Vue.use(VueFormGenerator)

export default {
  components: {
    FishingFreePoint,
    FishingResult,
    FishingStringShot,
    FishingWellboreObstruction,
    FishingResponsibleParties,
  },
  props: {
    // eslint-disable-next-line vue/require-default-prop
    submitId: {type: Number, default: undefined},
    editable: Boolean,
  },
  data() {
    return {
      form: [],
      show: true,
      hasData: false,
      editableOps: this.editable,
      optionComboWellStatus: [],
      optionComboFishingType: [],
      optionComboFishingCause: [],
      optionComboFishingImmediateCause: [],
    }
  },
  computed: {
    ...formComputed,
  },
  watch: {
    submitId: function (value) {
      this.init()
    },
    editable: function (val) {
      this.editableOps = val
    },
    form: function (val) {},
  },
  created: function () {
    this.init()
  },
  methods: {
    ...formMethods,
    init() {
      this.loadAllCombo()
      this.form = []
      this.getActivityFishingGeneral({
        params: { submitId: this.submitId },
      }).then((resp) => {
        if (resp.data.data.length > 0) {
          this.hasData = true
          this.form = resp.data.data[0]
        }
        console.log('this.hasData', this.hasData)
      })
    },
    loadAllCombo() {
      // form_id=general&combo_name=kick_proc&ref_id=

      this.optionComboWellStatus = []
      this.optionComboFishingType = []
      this.optionComboFishingCause = []
      this.optionComboFishingImmediateCause = []

      let dataCombo = [
        { option: 1, combo_name: 'well_status', ref_id: '' },
        { option: 2, combo_name: 'fishing_type', ref_id: '' },
        { option: 3, combo_name: 'fishing_cause', ref_id: '' },
        { option: 4, combo_name: 'fishing_intermediate_cause', ref_id: '' },
      ]

      dataCombo.forEach((data) => {
        this.getComboOptionList({
          params: {
            form_id: 'fishing',
            combo_name: data.combo_name,
            ref_id: data.ref_id,
          },
        }).then((resp) => {
          resp.data.data.forEach((d) => {
            switch (data.option) {
              case 1:
                this.optionComboWellStatus.push({
                  value: d.comboId,
                  text: d.comboValue,
                })
                break
              case 2:
                this.optionComboFishingType.push({
                  value: d.comboId,
                  text: d.comboValue,
                })
                break
              case 3:
                this.optionComboFishingCause.push({
                  value: d.comboId,
                  text: d.comboValue,
                })
                break
              case 4:
                this.optionComboFishingImmediateCause.push({
                  value: d.comboId,
                  text: d.comboValue,
                })
                break
              default:
                break
            }
            // data.option.push({ value: d.comboId, text: d.comboValue })
          })
        })
      })
    },
    makeToast(msg) {
      this.$bvToast.toast(msg, {
        title: 'Notification',
        autoHideDelay: 5000,
        appendToast: false,
      })
    },
    onSubmit(evt) {
      evt.preventDefault()

      if (this.hasData) {
        // if intId is exist that means data has already at server
        // time to update
        const data = { ...this.form }
        this.updateActivityFishingGeneral({ params: data }).then((resp) => {
          this.form.intId = resp.data.intId
          notify({ message: 'Data has been recorded.', width: 300 }, 'success', 5000)
        })
      } else {
        // time to insert
        const data = { ...this.form, submitId: this.submitId }
        this.addActivityFishingGeneral({ params: data }).then((resp) => {
          this.hasData = true
          notify({ message: 'Data has been recorded.', width: 300 }, 'success', 5000)
        })
      }
    },
    onReset(evt) {
      evt.preventDefault()
      this.form = []
      this.show = false
      this.$nextTick(() => {
        this.show = true
      })
    },
  },
}
</script>